import {
  leaveEndDate,
  leaveStartDate,
} from '@/lib/leave/leaveRequestFunctions';
import { LeaveRequest } from '../../../api/v1';

export const leaveDateFilter =
  (start: Date, end: Date, timezone: string) => (leave: LeaveRequest) =>
    leaveStartDate(leave, timezone) < end &&
    leaveEndDate(leave, timezone) > start;
